import React from 'react';
import Icon from '../Icon/Icon';

type AlertProps = {
  show: boolean;
  type: 'SUCCESS' | 'ERROR' | 'WARNING' | 'INFO';
  message: string;
  onAction?: () => void;
  onActionMessage?: string;
};

function Alert({ show, type, message, onActionMessage, onAction }: AlertProps) {
  const alertRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (show) {
      alertRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  }, [show]);

  return (
    <div ref={alertRef} className={`alert ${show ? 'show' : ''} alert--${type} -mt-[1px]`}>
      {show && (
        <div className="alert-message whitespace-normal break-words">
          {message}{' '}
          {onAction && (
            <button type="button" className="alert-action underline" onClick={onAction}>
              {onActionMessage}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export function Ping({ show, text }: { show: boolean; text?: string }) {
  return (
    <div
      className={`bg-[#72C16D] fixed pl-6 pr-4 py-2 top-7 rounded-md shadow-md
  text-white flex flex-row items-center justify-between text-[15px] transition-all ease-in-out ${
    show ? 'right-5 z-50' : 'right-[-150%]'
  }`}
    >
      {text || 'Ping message sent'}
      <span className="flex items-center justify-center w-9 h-9 ml-4">
        <span className="absolute animate-ping bg-[rgb(255,255,255)]/30 w-6 h-6 rounded-full" />
        <span className="relative rounded-full w-5 h-5 bg-white inline-flex items-center justify-center">
          <Icon id="checkmark" className="w-[10px] h-[10px] text-[#72C16D]" />
        </span>
      </span>
    </div>
  );
}

export default Alert;
